<template>
  <div id="areaUI" v-show="isShow">
    <div class="overlay">
      <div class="areaUI__buttons">
        <button @click="determineArea">ここに決める</button>
        <button @click="resetArea">reset</button>
      </div>
    </div>
    <div>
      {{ pos.x | round }},
      {{ pos.y | round }}
    </div>
  </div>
</template>

<script>
import * as modeTypes from "../../store/modules/mode/types";
import * as flowEvents from "../../events/FlowEvents";
import { isModeArea } from "../../util/StoreUtil";

export default {
  name: "AreaUI.vue",
  computed: {
    isShow() {
      return isModeArea();
    },
    pos() {
      return this.$store.state.area.pos;
    }
  },
  methods: {
    determineArea() {
      flowEvents.FlowEvents.emit(flowEvents.DETERMINE_AREA);
    },
    resetArea() {
      flowEvents.FlowEvents.emit(flowEvents.RESET_AREA);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
#areaUI
  position: absolute
  bottom: 0
  z-index: $z_header_ui
  pointer-events: none
  .areaUI__buttons
    pointer-events: all
</style>
